export enum AppType {
    FnB = 'fnb',
    Retail = 'retail'
}
